import { parseDashboardURL } from "./read_state.js";
import { closeFeedMenuForElement, closeOverlayElement } from "./sidebar_overlay.js";
import { shouldResetViewportForNavigation } from "./app_events_navigation.js";

function copyTextFromInputButton(button) {
  const inputID = button.getAttribute("data-copy-url-button");
  if (!inputID) {
    return;
  }

  const input = document.getElementById(inputID);
  if (!input) {
    return;
  }

  const text = input.value || "";
  if (!text) {
    return;
  }

  const original = button.textContent;
  const setLabel = function (label) {
    button.textContent = label;
    window.setTimeout(function () {
      button.textContent = original;
    }, 1200);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(function () {
      setLabel("Copied");
    }).catch(function () {
      input.select();
      document.execCommand("copy");
      setLabel("Copied");
    });
    return;
  }

  input.select();
  document.execCommand("copy");
  setLabel("Copied");
}

export function registerAccordionToggleHandler() {
  document.addEventListener("toggle", function (event) {
    const target = event.target;
    if (!(target instanceof HTMLDetailsElement)) {
      return;
    }
    if (!target.matches("details.accordion-item.linka-feed-card")) {
      return;
    }
    if (!target.open) {
      return;
    }

    document.querySelectorAll("details.accordion-item.linka-feed-card[open]").forEach(function (item) {
      if (item === target) {
        return;
      }
      item.removeAttribute("open");
    });
  });
}

export function registerDashboardInteractionHandlers(onRequestViewportReset) {
  document.addEventListener("click", function (event) {
    const openOverlay = event.target instanceof Element
      ? event.target.closest("#entry-overlay.is-open, #feed-overlay.is-open")
      : null;
    if (openOverlay instanceof HTMLElement) {
      const insideCard = event.target instanceof Element
        ? event.target.closest(".overlay-card")
        : null;
      if (!insideCard) {
        closeOverlayElement(openOverlay);
        return;
      }
    }

    const target = event.target instanceof Element
      ? event.target
      : (event.target && event.target.parentElement ? event.target.parentElement : null);
    if (!target) {
      return;
    }

    const sidebarNavLink = target.closest(".entries-sidebar a[href]");
    if (sidebarNavLink instanceof HTMLAnchorElement) {
      const href = String(sidebarNavLink.getAttribute("href") || "").trim();
      const currentURL = parseDashboardURL(window.location.pathname + window.location.search);
      const nextURL = parseDashboardURL(href);
      if (shouldResetViewportForNavigation(currentURL, nextURL)) {
        onRequestViewportReset();
      }
    }

    const menuHost = target.closest("details.sidebar-feed-menu");
    document.querySelectorAll("details.sidebar-feed-menu[open]").forEach(function (menu) {
      if (menuHost && menu === menuHost) {
        return;
      }
      menu.removeAttribute("open");
    });

    const bulkMenuHost = target.closest("details.dashboard-bulk-menu");
    document.querySelectorAll("details.dashboard-bulk-menu[open]").forEach(function (menu) {
      if (bulkMenuHost && menu === bulkMenuHost) {
        return;
      }
      menu.removeAttribute("open");
    });

    const menuAction = target.closest(".sidebar-feed-menu-item");
    if (menuAction instanceof HTMLElement) {
      closeFeedMenuForElement(menuAction);
    }

    const bulkAction = target.closest(".dashboard-bulk-menu-item");
    if (bulkAction instanceof HTMLElement) {
      const menu = bulkAction.closest("details.dashboard-bulk-menu");
      if (menu instanceof HTMLDetailsElement) {
        menu.removeAttribute("open");
      }
    }

    const sectionToggle = target.closest(".feed-section-arrow-toggle");
    if (sectionToggle) {
      const section = sectionToggle.closest(".feed-section");
      if (section) {
        const willCollapse = !section.classList.contains("is-collapsed");
        section.classList.toggle("is-collapsed", willCollapse);
        sectionToggle.setAttribute("aria-expanded", willCollapse ? "false" : "true");

        const form = sectionToggle.closest("form");
        if (form) {
          const collapsedInput = form.querySelector('input[name="collapsed"]');
          if (collapsedInput) {
            collapsedInput.value = willCollapse ? "1" : "0";
          }
        }
      }
    }

    const button = target.closest("[data-copy-url-button]");
    if (!(button instanceof HTMLElement)) {
      return;
    }

    copyTextFromInputButton(button);
  });
}
